export enum TableItemActionType {
  Command,
  More,
  RouterLink,
  Url,
}
